import StyledTable from 'app/components/StyledTable';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatNumber, getFromDateToDate } from 'utils/helper';

const ListGiftTicket = ({ dataSource }) => {
  const translations = useSelector(selectTranslations);

  const columnTicketGift = [
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-name']}
        </div>
      ),
      dataIndex: 'productName',
      key: 'productName',
      render: value => <div style={{ textAlign: 'left' }}>{value}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.park']}
        </div>
      ),
      dataIndex: 'park',
      key: 'park',
      render: value => <div style={{ textAlign: 'left' }}>{value?.name}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-type']}
        </div>
      ),
      dataIndex: 'catalog',
      key: 'catalog',
      render: value => <div style={{ textAlign: 'left' }}>{value?.name}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.valid-from']}
        </div>
      ),
      key: 'dateFrom',
      render: value => {
        const { fromDate } = getFromDateToDate(value);
        return <div style={{ textAlign: 'left' }}>{fromDate}</div>;
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.valid-to']}
        </div>
      ),
      key: 'dateTo',
      render: value => {
        const { toDate } = getFromDateToDate(value);
        return <div style={{ textAlign: 'left' }}>{toDate}</div>;
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.serial']}
        </div>
      ),
      key: 'dateTo',
      render: value => {
        return (
          <div style={{ textAlign: 'left' }}>
            {value?.sapVerifyCode || value?.vgsTicketCode}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.refund.discount']}
        </div>
      ),
      dataIndex: 'discountAmount',
      key: 'discountAmount',
      render: value => (
        <div style={{ textAlign: 'left' }}>
          {`${formatNumber(value).replaceAll(',', '.')}đ`}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.total-amount']}
        </div>
      ),
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      render: value => (
        <div style={{ textAlign: 'left' }}>
          {`${formatNumber(value).replaceAll(',', '.')}đ`}
        </div>
      ),
    },
  ];

  return (
    <StyledTable
      dataSource={dataSource}
      columns={columnTicketGift}
      pagination={false}
    />
  );
};

export default ListGiftTicket;
